import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setPermission as setPermissionAction, setPermissionLoading, selectPermission} from '../slices/permissionSlice'
import queryPermission from '../../api/queries/queryPermission'

export const usePermission = () => {
  const dispatch = useDispatch()
  const permission = useSelector(selectPermission)

  const {
    permission: queryPermissionData,
    loadingPermission,
    refetchPermission,
    errorLoadingPermission
  } = queryPermission()

  useEffect(() => {
    dispatch(setPermissionLoading(loadingPermission))
  }, [loadingPermission, dispatch])

  useEffect(() => {
    if (queryPermissionData) {
      dispatch(setPermissionAction(queryPermissionData))

      if (queryPermissionData?.healthEquityConditionList) {
        const {
          clientId,
          groupId: projectId,
          clientName,
          groupName: projectName,
          userRole
        } = queryPermissionData.healthEquityConditionList
        const sessionData = {clientId, projectId, clientName, projectName, userRole}

        for (const [key, value] of Object.entries(sessionData)) {
          sessionStorage.setItem(key, value)
        }
      }
    }
  }, [queryPermissionData, dispatch])

  return {
    permission,
    loadingPermission,
    refetchPermission,
    errorLoadingPermission
  }
}
